module.exports = __webpack_public_path__ + "static/media/E05_mapa_ubicacion.b503a2d5.png";